/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlanningMapRouteImport } from './routes/planning-map'
import { Route as MailWindowRouteImport } from './routes/mail-window'
import { Route as MailComposeRouteImport } from './routes/mail-compose'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IntakeWindowRouteImport } from './routes/intake-window'
import { Route as CountSheetRouteImport } from './routes/count-sheet'
import { Route as BulkCountSheetRouteImport } from './routes/bulk-count-sheet'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShellWorklistsRouteImport } from './routes/_shell/worklists'
import { Route as ShellWarehouseOrdersRouteImport } from './routes/_shell/warehouse-orders'
import { Route as ShellUsersRouteImport } from './routes/_shell/users'
import { Route as ShellTrackingRouteImport } from './routes/_shell/tracking'
import { Route as ShellSecretsRouteImport } from './routes/_shell/secrets'
import { Route as ShellScanDeskRouteImport } from './routes/_shell/scan-desk'
import { Route as ShellPlanningRouteImport } from './routes/_shell/planning'
import { Route as ShellPermissionsRouteImport } from './routes/_shell/permissions'
import { Route as ShellPerformanceRouteImport } from './routes/_shell/performance'
import { Route as ShellPendelRoutesRouteImport } from './routes/_shell/pendel-routes'
import { Route as ShellPalletCheckRouteImport } from './routes/_shell/pallet-check'
import { Route as ShellOrgRouteImport } from './routes/_shell/org'
import { Route as ShellOrderMailsRouteImport } from './routes/_shell/order-mails'
import { Route as ShellMissingCmrsRouteImport } from './routes/_shell/missing-cmrs'
import { Route as ShellIntegrationsRouteImport } from './routes/_shell/integrations'
import { Route as ShellFocusAreasRouteImport } from './routes/_shell/focus-areas'
import { Route as ShellDocumentsRouteImport } from './routes/_shell/documents'
import { Route as ShellDocumentCheckRouteImport } from './routes/_shell/document-check'
import { Route as ShellDashboardRouteImport } from './routes/_shell/dashboard'
import { Route as ShellConsignmentRequirementsRouteImport } from './routes/_shell/consignment-requirements'
import { Route as ShellCarryOverRouteImport } from './routes/_shell/carry-over'
import { Route as ShellBranchesRouteImport } from './routes/_shell/branches'
import { Route as ShellAdrCodesRouteImport } from './routes/_shell/adr-codes'
import { Route as ShellTripsIndexRouteImport } from './routes/_shell/trips/index'
import { Route as ShellTransportUnitsIndexRouteImport } from './routes/_shell/transport-units/index'
import { Route as ShellTasksIndexRouteImport } from './routes/_shell/tasks/index'
import { Route as ShellStandingOrdersIndexRouteImport } from './routes/_shell/standing-orders/index'
import { Route as ShellReservationsIndexRouteImport } from './routes/_shell/reservations/index'
import { Route as ShellRequirementsIndexRouteImport } from './routes/_shell/requirements/index'
import { Route as ShellPurchaseInvoicesIndexRouteImport } from './routes/_shell/purchase-invoices/index'
import { Route as ShellPartiesIndexRouteImport } from './routes/_shell/parties/index'
import { Route as ShellPalletAccountsIndexRouteImport } from './routes/_shell/pallet-accounts/index'
import { Route as ShellOrdersIndexRouteImport } from './routes/_shell/orders/index'
import { Route as ShellMailIndexRouteImport } from './routes/_shell/mail/index'
import { Route as ShellLocationsIndexRouteImport } from './routes/_shell/locations/index'
import { Route as ShellIntakeIndexRouteImport } from './routes/_shell/intake/index'
import { Route as ShellDriversIndexRouteImport } from './routes/_shell/drivers/index'
import { Route as ShellDossiersIndexRouteImport } from './routes/_shell/dossiers/index'
import { Route as ShellCalendarIndexRouteImport } from './routes/_shell/calendar/index'
import { Route as ShellWarehouseWorkRouteImport } from './routes/_shell/warehouse/work'
import { Route as ShellWarehouseVasRouteImport } from './routes/_shell/warehouse/vas'
import { Route as ShellWarehouseStockRouteImport } from './routes/_shell/warehouse/stock'
import { Route as ShellWarehouseScannerUsersRouteImport } from './routes/_shell/warehouse/scanner-users'
import { Route as ShellWarehouseReplenishmentRouteImport } from './routes/_shell/warehouse/replenishment'
import { Route as ShellWarehouseLocationsRouteImport } from './routes/_shell/warehouse/locations'
import { Route as ShellWarehouseCrossdockRouteImport } from './routes/_shell/warehouse/crossdock'
import { Route as ShellWarehouseConfirmationsRouteImport } from './routes/_shell/warehouse/confirmations'
import { Route as ShellWarehouseArticlesRouteImport } from './routes/_shell/warehouse/articles'
import { Route as ShellWarehouseOrdersNewRouteImport } from './routes/_shell/warehouse-orders_.new'
import { Route as ShellTripsIdRouteImport } from './routes/_shell/trips/$id'
import { Route as ShellTransportUnitsRdwRouteImport } from './routes/_shell/transport-units/rdw'
import { Route as ShellTasksRecurringRouteImport } from './routes/_shell/tasks/recurring'
import { Route as ShellTasksCategoriesRouteImport } from './routes/_shell/tasks/categories'
import { Route as ShellTasksIdRouteImport } from './routes/_shell/tasks/$id'
import { Route as ShellStandingOrdersIdRouteImport } from './routes/_shell/standing-orders/$id'
import { Route as ShellReservationsResourcesRouteImport } from './routes/_shell/reservations/resources'
import { Route as ShellPurchaseInvoicesReadFeedbackRouteImport } from './routes/_shell/purchase-invoices/read-feedback'
import { Route as ShellPurchaseInvoicesFuelCardProductsRouteImport } from './routes/_shell/purchase-invoices/fuel-card-products'
import { Route as ShellPurchaseInvoicesCodingRulesRouteImport } from './routes/_shell/purchase-invoices/coding-rules'
import { Route as ShellPurchaseInvoicesIdRouteImport } from './routes/_shell/purchase-invoices/$id'
import { Route as ShellPartiesIdRouteImport } from './routes/_shell/parties/$id'
import { Route as ShellPalletAccountsPartyIdRouteImport } from './routes/_shell/pallet-accounts/$partyId'
import { Route as ShellOrdersNewRouteImport } from './routes/_shell/orders/new'
import { Route as ShellOrdersIdRouteImport } from './routes/_shell/orders/$id'
import { Route as ShellMailMailboxesRouteImport } from './routes/_shell/mail/mailboxes'
import { Route as ShellLocationsDuplicatesRouteImport } from './routes/_shell/locations/duplicates'
import { Route as ShellLocationsIdRouteImport } from './routes/_shell/locations/$id'
import { Route as ShellIntakeIdRouteImport } from './routes/_shell/intake/$id'
import { Route as ShellDriversIdRouteImport } from './routes/_shell/drivers/$id'
import { Route as ShellDossiersIdRouteImport } from './routes/_shell/dossiers/$id'
import { Route as ShellBillingWarehouseRouteImport } from './routes/_shell/billing/warehouse'
import { Route as ShellBillingInvoicesRouteImport } from './routes/_shell/billing/invoices'
import { Route as ShellBillingDieselRouteImport } from './routes/_shell/billing/diesel'
import { Route as ShellWarehouseSettingsIndexRouteImport } from './routes/_shell/warehouse/settings/index'
import { Route as ShellWarehouseOutboundIndexRouteImport } from './routes/_shell/warehouse/outbound/index'
import { Route as ShellWarehouseInboundIndexRouteImport } from './routes/_shell/warehouse/inbound/index'
import { Route as ShellBillingTariffsIndexRouteImport } from './routes/_shell/billing/tariffs/index'
import { Route as ShellWarehouseSettingsOwnerIdRouteImport } from './routes/_shell/warehouse/settings/$ownerId'
import { Route as ShellWarehouseOutboundIdRouteImport } from './routes/_shell/warehouse/outbound/$id'
import { Route as ShellWarehouseInboundIdRouteImport } from './routes/_shell/warehouse/inbound/$id'
import { Route as ShellTransportUnitsVehiclesIdRouteImport } from './routes/_shell/transport-units/vehicles/$id'
import { Route as ShellTransportUnitsEquipmentIdRouteImport } from './routes/_shell/transport-units/equipment/$id'
import { Route as ShellOrdersNewFromMessageRouteImport } from './routes/_shell/orders/new_.from-message'
import { Route as ShellBillingTariffsIdRouteImport } from './routes/_shell/billing/tariffs/$id'
import { Route as ShellBillingTariffsCustomersPartyIdRouteImport } from './routes/_shell/billing/tariffs/customers/$partyId'

const PlanningMapRoute = PlanningMapRouteImport.update({
  id: '/planning-map',
  path: '/planning-map',
  getParentRoute: () => rootRouteImport,
} as any)
const MailWindowRoute = MailWindowRouteImport.update({
  id: '/mail-window',
  path: '/mail-window',
  getParentRoute: () => rootRouteImport,
} as any)
const MailComposeRoute = MailComposeRouteImport.update({
  id: '/mail-compose',
  path: '/mail-compose',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IntakeWindowRoute = IntakeWindowRouteImport.update({
  id: '/intake-window',
  path: '/intake-window',
  getParentRoute: () => rootRouteImport,
} as any)
const CountSheetRoute = CountSheetRouteImport.update({
  id: '/count-sheet',
  path: '/count-sheet',
  getParentRoute: () => rootRouteImport,
} as any)
const BulkCountSheetRoute = BulkCountSheetRouteImport.update({
  id: '/bulk-count-sheet',
  path: '/bulk-count-sheet',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellWorklistsRoute = ShellWorklistsRouteImport.update({
  id: '/worklists',
  path: '/worklists',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseOrdersRoute = ShellWarehouseOrdersRouteImport.update({
  id: '/warehouse-orders',
  path: '/warehouse-orders',
  getParentRoute: () => ShellRoute,
} as any)
const ShellUsersRoute = ShellUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTrackingRoute = ShellTrackingRouteImport.update({
  id: '/tracking',
  path: '/tracking',
  getParentRoute: () => ShellRoute,
} as any)
const ShellSecretsRoute = ShellSecretsRouteImport.update({
  id: '/secrets',
  path: '/secrets',
  getParentRoute: () => ShellRoute,
} as any)
const ShellScanDeskRoute = ShellScanDeskRouteImport.update({
  id: '/scan-desk',
  path: '/scan-desk',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPlanningRoute = ShellPlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPermissionsRoute = ShellPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPerformanceRoute = ShellPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPendelRoutesRoute = ShellPendelRoutesRouteImport.update({
  id: '/pendel-routes',
  path: '/pendel-routes',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPalletCheckRoute = ShellPalletCheckRouteImport.update({
  id: '/pallet-check',
  path: '/pallet-check',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrgRoute = ShellOrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrderMailsRoute = ShellOrderMailsRouteImport.update({
  id: '/order-mails',
  path: '/order-mails',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMissingCmrsRoute = ShellMissingCmrsRouteImport.update({
  id: '/missing-cmrs',
  path: '/missing-cmrs',
  getParentRoute: () => ShellRoute,
} as any)
const ShellIntegrationsRoute = ShellIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => ShellRoute,
} as any)
const ShellFocusAreasRoute = ShellFocusAreasRouteImport.update({
  id: '/focus-areas',
  path: '/focus-areas',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDocumentsRoute = ShellDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDocumentCheckRoute = ShellDocumentCheckRouteImport.update({
  id: '/document-check',
  path: '/document-check',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDashboardRoute = ShellDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ShellRoute,
} as any)
const ShellConsignmentRequirementsRoute =
  ShellConsignmentRequirementsRouteImport.update({
    id: '/consignment-requirements',
    path: '/consignment-requirements',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellCarryOverRoute = ShellCarryOverRouteImport.update({
  id: '/carry-over',
  path: '/carry-over',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBranchesRoute = ShellBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAdrCodesRoute = ShellAdrCodesRouteImport.update({
  id: '/adr-codes',
  path: '/adr-codes',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTripsIndexRoute = ShellTripsIndexRouteImport.update({
  id: '/trips/',
  path: '/trips/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTransportUnitsIndexRoute =
  ShellTransportUnitsIndexRouteImport.update({
    id: '/transport-units/',
    path: '/transport-units/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellTasksIndexRoute = ShellTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStandingOrdersIndexRoute =
  ShellStandingOrdersIndexRouteImport.update({
    id: '/standing-orders/',
    path: '/standing-orders/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellReservationsIndexRoute = ShellReservationsIndexRouteImport.update({
  id: '/reservations/',
  path: '/reservations/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRequirementsIndexRoute = ShellRequirementsIndexRouteImport.update({
  id: '/requirements/',
  path: '/requirements/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPurchaseInvoicesIndexRoute =
  ShellPurchaseInvoicesIndexRouteImport.update({
    id: '/purchase-invoices/',
    path: '/purchase-invoices/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellPartiesIndexRoute = ShellPartiesIndexRouteImport.update({
  id: '/parties/',
  path: '/parties/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPalletAccountsIndexRoute =
  ShellPalletAccountsIndexRouteImport.update({
    id: '/pallet-accounts/',
    path: '/pallet-accounts/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellOrdersIndexRoute = ShellOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMailIndexRoute = ShellMailIndexRouteImport.update({
  id: '/mail/',
  path: '/mail/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLocationsIndexRoute = ShellLocationsIndexRouteImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellIntakeIndexRoute = ShellIntakeIndexRouteImport.update({
  id: '/intake/',
  path: '/intake/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDriversIndexRoute = ShellDriversIndexRouteImport.update({
  id: '/drivers/',
  path: '/drivers/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDossiersIndexRoute = ShellDossiersIndexRouteImport.update({
  id: '/dossiers/',
  path: '/dossiers/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCalendarIndexRoute = ShellCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseWorkRoute = ShellWarehouseWorkRouteImport.update({
  id: '/warehouse/work',
  path: '/warehouse/work',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseVasRoute = ShellWarehouseVasRouteImport.update({
  id: '/warehouse/vas',
  path: '/warehouse/vas',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseStockRoute = ShellWarehouseStockRouteImport.update({
  id: '/warehouse/stock',
  path: '/warehouse/stock',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseScannerUsersRoute =
  ShellWarehouseScannerUsersRouteImport.update({
    id: '/warehouse/scanner-users',
    path: '/warehouse/scanner-users',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellWarehouseReplenishmentRoute =
  ShellWarehouseReplenishmentRouteImport.update({
    id: '/warehouse/replenishment',
    path: '/warehouse/replenishment',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellWarehouseLocationsRoute = ShellWarehouseLocationsRouteImport.update({
  id: '/warehouse/locations',
  path: '/warehouse/locations',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseCrossdockRoute = ShellWarehouseCrossdockRouteImport.update({
  id: '/warehouse/crossdock',
  path: '/warehouse/crossdock',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseConfirmationsRoute =
  ShellWarehouseConfirmationsRouteImport.update({
    id: '/warehouse/confirmations',
    path: '/warehouse/confirmations',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellWarehouseArticlesRoute = ShellWarehouseArticlesRouteImport.update({
  id: '/warehouse/articles',
  path: '/warehouse/articles',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseOrdersNewRoute = ShellWarehouseOrdersNewRouteImport.update({
  id: '/warehouse-orders_/new',
  path: '/warehouse-orders/new',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTripsIdRoute = ShellTripsIdRouteImport.update({
  id: '/trips/$id',
  path: '/trips/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTransportUnitsRdwRoute = ShellTransportUnitsRdwRouteImport.update({
  id: '/transport-units/rdw',
  path: '/transport-units/rdw',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTasksRecurringRoute = ShellTasksRecurringRouteImport.update({
  id: '/tasks/recurring',
  path: '/tasks/recurring',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTasksCategoriesRoute = ShellTasksCategoriesRouteImport.update({
  id: '/tasks/categories',
  path: '/tasks/categories',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTasksIdRoute = ShellTasksIdRouteImport.update({
  id: '/tasks/$id',
  path: '/tasks/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStandingOrdersIdRoute = ShellStandingOrdersIdRouteImport.update({
  id: '/standing-orders/$id',
  path: '/standing-orders/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellReservationsResourcesRoute =
  ShellReservationsResourcesRouteImport.update({
    id: '/reservations/resources',
    path: '/reservations/resources',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellPurchaseInvoicesReadFeedbackRoute =
  ShellPurchaseInvoicesReadFeedbackRouteImport.update({
    id: '/purchase-invoices/read-feedback',
    path: '/purchase-invoices/read-feedback',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellPurchaseInvoicesFuelCardProductsRoute =
  ShellPurchaseInvoicesFuelCardProductsRouteImport.update({
    id: '/purchase-invoices/fuel-card-products',
    path: '/purchase-invoices/fuel-card-products',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellPurchaseInvoicesCodingRulesRoute =
  ShellPurchaseInvoicesCodingRulesRouteImport.update({
    id: '/purchase-invoices/coding-rules',
    path: '/purchase-invoices/coding-rules',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellPurchaseInvoicesIdRoute = ShellPurchaseInvoicesIdRouteImport.update({
  id: '/purchase-invoices/$id',
  path: '/purchase-invoices/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPartiesIdRoute = ShellPartiesIdRouteImport.update({
  id: '/parties/$id',
  path: '/parties/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPalletAccountsPartyIdRoute =
  ShellPalletAccountsPartyIdRouteImport.update({
    id: '/pallet-accounts/$partyId',
    path: '/pallet-accounts/$partyId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellOrdersNewRoute = ShellOrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOrdersIdRoute = ShellOrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellMailMailboxesRoute = ShellMailMailboxesRouteImport.update({
  id: '/mail/mailboxes',
  path: '/mail/mailboxes',
  getParentRoute: () => ShellRoute,
} as any)
const ShellLocationsDuplicatesRoute =
  ShellLocationsDuplicatesRouteImport.update({
    id: '/locations/duplicates',
    path: '/locations/duplicates',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellLocationsIdRoute = ShellLocationsIdRouteImport.update({
  id: '/locations/$id',
  path: '/locations/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellIntakeIdRoute = ShellIntakeIdRouteImport.update({
  id: '/intake/$id',
  path: '/intake/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDriversIdRoute = ShellDriversIdRouteImport.update({
  id: '/drivers/$id',
  path: '/drivers/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDossiersIdRoute = ShellDossiersIdRouteImport.update({
  id: '/dossiers/$id',
  path: '/dossiers/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBillingWarehouseRoute = ShellBillingWarehouseRouteImport.update({
  id: '/billing/warehouse',
  path: '/billing/warehouse',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBillingInvoicesRoute = ShellBillingInvoicesRouteImport.update({
  id: '/billing/invoices',
  path: '/billing/invoices',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBillingDieselRoute = ShellBillingDieselRouteImport.update({
  id: '/billing/diesel',
  path: '/billing/diesel',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWarehouseSettingsIndexRoute =
  ShellWarehouseSettingsIndexRouteImport.update({
    id: '/warehouse/settings/',
    path: '/warehouse/settings/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellWarehouseOutboundIndexRoute =
  ShellWarehouseOutboundIndexRouteImport.update({
    id: '/warehouse/outbound/',
    path: '/warehouse/outbound/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellWarehouseInboundIndexRoute =
  ShellWarehouseInboundIndexRouteImport.update({
    id: '/warehouse/inbound/',
    path: '/warehouse/inbound/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellBillingTariffsIndexRoute =
  ShellBillingTariffsIndexRouteImport.update({
    id: '/billing/tariffs/',
    path: '/billing/tariffs/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellWarehouseSettingsOwnerIdRoute =
  ShellWarehouseSettingsOwnerIdRouteImport.update({
    id: '/warehouse/settings/$ownerId',
    path: '/warehouse/settings/$ownerId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellWarehouseOutboundIdRoute =
  ShellWarehouseOutboundIdRouteImport.update({
    id: '/warehouse/outbound/$id',
    path: '/warehouse/outbound/$id',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellWarehouseInboundIdRoute = ShellWarehouseInboundIdRouteImport.update({
  id: '/warehouse/inbound/$id',
  path: '/warehouse/inbound/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellTransportUnitsVehiclesIdRoute =
  ShellTransportUnitsVehiclesIdRouteImport.update({
    id: '/transport-units/vehicles/$id',
    path: '/transport-units/vehicles/$id',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellTransportUnitsEquipmentIdRoute =
  ShellTransportUnitsEquipmentIdRouteImport.update({
    id: '/transport-units/equipment/$id',
    path: '/transport-units/equipment/$id',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellOrdersNewFromMessageRoute =
  ShellOrdersNewFromMessageRouteImport.update({
    id: '/orders/new_/from-message',
    path: '/orders/new/from-message',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellBillingTariffsIdRoute = ShellBillingTariffsIdRouteImport.update({
  id: '/billing/tariffs/$id',
  path: '/billing/tariffs/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBillingTariffsCustomersPartyIdRoute =
  ShellBillingTariffsCustomersPartyIdRouteImport.update({
    id: '/billing/tariffs/customers/$partyId',
    path: '/billing/tariffs/customers/$partyId',
    getParentRoute: () => ShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bulk-count-sheet': typeof BulkCountSheetRoute
  '/count-sheet': typeof CountSheetRoute
  '/intake-window': typeof IntakeWindowRoute
  '/login': typeof LoginRoute
  '/mail-compose': typeof MailComposeRoute
  '/mail-window': typeof MailWindowRoute
  '/planning-map': typeof PlanningMapRoute
  '/adr-codes': typeof ShellAdrCodesRoute
  '/branches': typeof ShellBranchesRoute
  '/carry-over': typeof ShellCarryOverRoute
  '/consignment-requirements': typeof ShellConsignmentRequirementsRoute
  '/dashboard': typeof ShellDashboardRoute
  '/document-check': typeof ShellDocumentCheckRoute
  '/documents': typeof ShellDocumentsRoute
  '/focus-areas': typeof ShellFocusAreasRoute
  '/integrations': typeof ShellIntegrationsRoute
  '/missing-cmrs': typeof ShellMissingCmrsRoute
  '/order-mails': typeof ShellOrderMailsRoute
  '/org': typeof ShellOrgRoute
  '/pallet-check': typeof ShellPalletCheckRoute
  '/pendel-routes': typeof ShellPendelRoutesRoute
  '/performance': typeof ShellPerformanceRoute
  '/permissions': typeof ShellPermissionsRoute
  '/planning': typeof ShellPlanningRoute
  '/scan-desk': typeof ShellScanDeskRoute
  '/secrets': typeof ShellSecretsRoute
  '/tracking': typeof ShellTrackingRoute
  '/users': typeof ShellUsersRoute
  '/warehouse-orders': typeof ShellWarehouseOrdersRoute
  '/worklists': typeof ShellWorklistsRoute
  '/billing/diesel': typeof ShellBillingDieselRoute
  '/billing/invoices': typeof ShellBillingInvoicesRoute
  '/billing/warehouse': typeof ShellBillingWarehouseRoute
  '/dossiers/$id': typeof ShellDossiersIdRoute
  '/drivers/$id': typeof ShellDriversIdRoute
  '/intake/$id': typeof ShellIntakeIdRoute
  '/locations/$id': typeof ShellLocationsIdRoute
  '/locations/duplicates': typeof ShellLocationsDuplicatesRoute
  '/mail/mailboxes': typeof ShellMailMailboxesRoute
  '/orders/$id': typeof ShellOrdersIdRoute
  '/orders/new': typeof ShellOrdersNewRoute
  '/pallet-accounts/$partyId': typeof ShellPalletAccountsPartyIdRoute
  '/parties/$id': typeof ShellPartiesIdRoute
  '/purchase-invoices/$id': typeof ShellPurchaseInvoicesIdRoute
  '/purchase-invoices/coding-rules': typeof ShellPurchaseInvoicesCodingRulesRoute
  '/purchase-invoices/fuel-card-products': typeof ShellPurchaseInvoicesFuelCardProductsRoute
  '/purchase-invoices/read-feedback': typeof ShellPurchaseInvoicesReadFeedbackRoute
  '/reservations/resources': typeof ShellReservationsResourcesRoute
  '/standing-orders/$id': typeof ShellStandingOrdersIdRoute
  '/tasks/$id': typeof ShellTasksIdRoute
  '/tasks/categories': typeof ShellTasksCategoriesRoute
  '/tasks/recurring': typeof ShellTasksRecurringRoute
  '/transport-units/rdw': typeof ShellTransportUnitsRdwRoute
  '/trips/$id': typeof ShellTripsIdRoute
  '/warehouse-orders/new': typeof ShellWarehouseOrdersNewRoute
  '/warehouse/articles': typeof ShellWarehouseArticlesRoute
  '/warehouse/confirmations': typeof ShellWarehouseConfirmationsRoute
  '/warehouse/crossdock': typeof ShellWarehouseCrossdockRoute
  '/warehouse/locations': typeof ShellWarehouseLocationsRoute
  '/warehouse/replenishment': typeof ShellWarehouseReplenishmentRoute
  '/warehouse/scanner-users': typeof ShellWarehouseScannerUsersRoute
  '/warehouse/stock': typeof ShellWarehouseStockRoute
  '/warehouse/vas': typeof ShellWarehouseVasRoute
  '/warehouse/work': typeof ShellWarehouseWorkRoute
  '/calendar/': typeof ShellCalendarIndexRoute
  '/dossiers/': typeof ShellDossiersIndexRoute
  '/drivers/': typeof ShellDriversIndexRoute
  '/intake/': typeof ShellIntakeIndexRoute
  '/locations/': typeof ShellLocationsIndexRoute
  '/mail/': typeof ShellMailIndexRoute
  '/orders/': typeof ShellOrdersIndexRoute
  '/pallet-accounts/': typeof ShellPalletAccountsIndexRoute
  '/parties/': typeof ShellPartiesIndexRoute
  '/purchase-invoices/': typeof ShellPurchaseInvoicesIndexRoute
  '/requirements/': typeof ShellRequirementsIndexRoute
  '/reservations/': typeof ShellReservationsIndexRoute
  '/standing-orders/': typeof ShellStandingOrdersIndexRoute
  '/tasks/': typeof ShellTasksIndexRoute
  '/transport-units/': typeof ShellTransportUnitsIndexRoute
  '/trips/': typeof ShellTripsIndexRoute
  '/billing/tariffs/$id': typeof ShellBillingTariffsIdRoute
  '/orders/new/from-message': typeof ShellOrdersNewFromMessageRoute
  '/transport-units/equipment/$id': typeof ShellTransportUnitsEquipmentIdRoute
  '/transport-units/vehicles/$id': typeof ShellTransportUnitsVehiclesIdRoute
  '/warehouse/inbound/$id': typeof ShellWarehouseInboundIdRoute
  '/warehouse/outbound/$id': typeof ShellWarehouseOutboundIdRoute
  '/warehouse/settings/$ownerId': typeof ShellWarehouseSettingsOwnerIdRoute
  '/billing/tariffs/': typeof ShellBillingTariffsIndexRoute
  '/warehouse/inbound/': typeof ShellWarehouseInboundIndexRoute
  '/warehouse/outbound/': typeof ShellWarehouseOutboundIndexRoute
  '/warehouse/settings/': typeof ShellWarehouseSettingsIndexRoute
  '/billing/tariffs/customers/$partyId': typeof ShellBillingTariffsCustomersPartyIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bulk-count-sheet': typeof BulkCountSheetRoute
  '/count-sheet': typeof CountSheetRoute
  '/intake-window': typeof IntakeWindowRoute
  '/login': typeof LoginRoute
  '/mail-compose': typeof MailComposeRoute
  '/mail-window': typeof MailWindowRoute
  '/planning-map': typeof PlanningMapRoute
  '/adr-codes': typeof ShellAdrCodesRoute
  '/branches': typeof ShellBranchesRoute
  '/carry-over': typeof ShellCarryOverRoute
  '/consignment-requirements': typeof ShellConsignmentRequirementsRoute
  '/dashboard': typeof ShellDashboardRoute
  '/document-check': typeof ShellDocumentCheckRoute
  '/documents': typeof ShellDocumentsRoute
  '/focus-areas': typeof ShellFocusAreasRoute
  '/integrations': typeof ShellIntegrationsRoute
  '/missing-cmrs': typeof ShellMissingCmrsRoute
  '/order-mails': typeof ShellOrderMailsRoute
  '/org': typeof ShellOrgRoute
  '/pallet-check': typeof ShellPalletCheckRoute
  '/pendel-routes': typeof ShellPendelRoutesRoute
  '/performance': typeof ShellPerformanceRoute
  '/permissions': typeof ShellPermissionsRoute
  '/planning': typeof ShellPlanningRoute
  '/scan-desk': typeof ShellScanDeskRoute
  '/secrets': typeof ShellSecretsRoute
  '/tracking': typeof ShellTrackingRoute
  '/users': typeof ShellUsersRoute
  '/warehouse-orders': typeof ShellWarehouseOrdersRoute
  '/worklists': typeof ShellWorklistsRoute
  '/billing/diesel': typeof ShellBillingDieselRoute
  '/billing/invoices': typeof ShellBillingInvoicesRoute
  '/billing/warehouse': typeof ShellBillingWarehouseRoute
  '/dossiers/$id': typeof ShellDossiersIdRoute
  '/drivers/$id': typeof ShellDriversIdRoute
  '/intake/$id': typeof ShellIntakeIdRoute
  '/locations/$id': typeof ShellLocationsIdRoute
  '/locations/duplicates': typeof ShellLocationsDuplicatesRoute
  '/mail/mailboxes': typeof ShellMailMailboxesRoute
  '/orders/$id': typeof ShellOrdersIdRoute
  '/orders/new': typeof ShellOrdersNewRoute
  '/pallet-accounts/$partyId': typeof ShellPalletAccountsPartyIdRoute
  '/parties/$id': typeof ShellPartiesIdRoute
  '/purchase-invoices/$id': typeof ShellPurchaseInvoicesIdRoute
  '/purchase-invoices/coding-rules': typeof ShellPurchaseInvoicesCodingRulesRoute
  '/purchase-invoices/fuel-card-products': typeof ShellPurchaseInvoicesFuelCardProductsRoute
  '/purchase-invoices/read-feedback': typeof ShellPurchaseInvoicesReadFeedbackRoute
  '/reservations/resources': typeof ShellReservationsResourcesRoute
  '/standing-orders/$id': typeof ShellStandingOrdersIdRoute
  '/tasks/$id': typeof ShellTasksIdRoute
  '/tasks/categories': typeof ShellTasksCategoriesRoute
  '/tasks/recurring': typeof ShellTasksRecurringRoute
  '/transport-units/rdw': typeof ShellTransportUnitsRdwRoute
  '/trips/$id': typeof ShellTripsIdRoute
  '/warehouse-orders/new': typeof ShellWarehouseOrdersNewRoute
  '/warehouse/articles': typeof ShellWarehouseArticlesRoute
  '/warehouse/confirmations': typeof ShellWarehouseConfirmationsRoute
  '/warehouse/crossdock': typeof ShellWarehouseCrossdockRoute
  '/warehouse/locations': typeof ShellWarehouseLocationsRoute
  '/warehouse/replenishment': typeof ShellWarehouseReplenishmentRoute
  '/warehouse/scanner-users': typeof ShellWarehouseScannerUsersRoute
  '/warehouse/stock': typeof ShellWarehouseStockRoute
  '/warehouse/vas': typeof ShellWarehouseVasRoute
  '/warehouse/work': typeof ShellWarehouseWorkRoute
  '/calendar': typeof ShellCalendarIndexRoute
  '/dossiers': typeof ShellDossiersIndexRoute
  '/drivers': typeof ShellDriversIndexRoute
  '/intake': typeof ShellIntakeIndexRoute
  '/locations': typeof ShellLocationsIndexRoute
  '/mail': typeof ShellMailIndexRoute
  '/orders': typeof ShellOrdersIndexRoute
  '/pallet-accounts': typeof ShellPalletAccountsIndexRoute
  '/parties': typeof ShellPartiesIndexRoute
  '/purchase-invoices': typeof ShellPurchaseInvoicesIndexRoute
  '/requirements': typeof ShellRequirementsIndexRoute
  '/reservations': typeof ShellReservationsIndexRoute
  '/standing-orders': typeof ShellStandingOrdersIndexRoute
  '/tasks': typeof ShellTasksIndexRoute
  '/transport-units': typeof ShellTransportUnitsIndexRoute
  '/trips': typeof ShellTripsIndexRoute
  '/billing/tariffs/$id': typeof ShellBillingTariffsIdRoute
  '/orders/new/from-message': typeof ShellOrdersNewFromMessageRoute
  '/transport-units/equipment/$id': typeof ShellTransportUnitsEquipmentIdRoute
  '/transport-units/vehicles/$id': typeof ShellTransportUnitsVehiclesIdRoute
  '/warehouse/inbound/$id': typeof ShellWarehouseInboundIdRoute
  '/warehouse/outbound/$id': typeof ShellWarehouseOutboundIdRoute
  '/warehouse/settings/$ownerId': typeof ShellWarehouseSettingsOwnerIdRoute
  '/billing/tariffs': typeof ShellBillingTariffsIndexRoute
  '/warehouse/inbound': typeof ShellWarehouseInboundIndexRoute
  '/warehouse/outbound': typeof ShellWarehouseOutboundIndexRoute
  '/warehouse/settings': typeof ShellWarehouseSettingsIndexRoute
  '/billing/tariffs/customers/$partyId': typeof ShellBillingTariffsCustomersPartyIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_shell': typeof ShellRouteWithChildren
  '/bulk-count-sheet': typeof BulkCountSheetRoute
  '/count-sheet': typeof CountSheetRoute
  '/intake-window': typeof IntakeWindowRoute
  '/login': typeof LoginRoute
  '/mail-compose': typeof MailComposeRoute
  '/mail-window': typeof MailWindowRoute
  '/planning-map': typeof PlanningMapRoute
  '/_shell/adr-codes': typeof ShellAdrCodesRoute
  '/_shell/branches': typeof ShellBranchesRoute
  '/_shell/carry-over': typeof ShellCarryOverRoute
  '/_shell/consignment-requirements': typeof ShellConsignmentRequirementsRoute
  '/_shell/dashboard': typeof ShellDashboardRoute
  '/_shell/document-check': typeof ShellDocumentCheckRoute
  '/_shell/documents': typeof ShellDocumentsRoute
  '/_shell/focus-areas': typeof ShellFocusAreasRoute
  '/_shell/integrations': typeof ShellIntegrationsRoute
  '/_shell/missing-cmrs': typeof ShellMissingCmrsRoute
  '/_shell/order-mails': typeof ShellOrderMailsRoute
  '/_shell/org': typeof ShellOrgRoute
  '/_shell/pallet-check': typeof ShellPalletCheckRoute
  '/_shell/pendel-routes': typeof ShellPendelRoutesRoute
  '/_shell/performance': typeof ShellPerformanceRoute
  '/_shell/permissions': typeof ShellPermissionsRoute
  '/_shell/planning': typeof ShellPlanningRoute
  '/_shell/scan-desk': typeof ShellScanDeskRoute
  '/_shell/secrets': typeof ShellSecretsRoute
  '/_shell/tracking': typeof ShellTrackingRoute
  '/_shell/users': typeof ShellUsersRoute
  '/_shell/warehouse-orders': typeof ShellWarehouseOrdersRoute
  '/_shell/worklists': typeof ShellWorklistsRoute
  '/_shell/billing/diesel': typeof ShellBillingDieselRoute
  '/_shell/billing/invoices': typeof ShellBillingInvoicesRoute
  '/_shell/billing/warehouse': typeof ShellBillingWarehouseRoute
  '/_shell/dossiers/$id': typeof ShellDossiersIdRoute
  '/_shell/drivers/$id': typeof ShellDriversIdRoute
  '/_shell/intake/$id': typeof ShellIntakeIdRoute
  '/_shell/locations/$id': typeof ShellLocationsIdRoute
  '/_shell/locations/duplicates': typeof ShellLocationsDuplicatesRoute
  '/_shell/mail/mailboxes': typeof ShellMailMailboxesRoute
  '/_shell/orders/$id': typeof ShellOrdersIdRoute
  '/_shell/orders/new': typeof ShellOrdersNewRoute
  '/_shell/pallet-accounts/$partyId': typeof ShellPalletAccountsPartyIdRoute
  '/_shell/parties/$id': typeof ShellPartiesIdRoute
  '/_shell/purchase-invoices/$id': typeof ShellPurchaseInvoicesIdRoute
  '/_shell/purchase-invoices/coding-rules': typeof ShellPurchaseInvoicesCodingRulesRoute
  '/_shell/purchase-invoices/fuel-card-products': typeof ShellPurchaseInvoicesFuelCardProductsRoute
  '/_shell/purchase-invoices/read-feedback': typeof ShellPurchaseInvoicesReadFeedbackRoute
  '/_shell/reservations/resources': typeof ShellReservationsResourcesRoute
  '/_shell/standing-orders/$id': typeof ShellStandingOrdersIdRoute
  '/_shell/tasks/$id': typeof ShellTasksIdRoute
  '/_shell/tasks/categories': typeof ShellTasksCategoriesRoute
  '/_shell/tasks/recurring': typeof ShellTasksRecurringRoute
  '/_shell/transport-units/rdw': typeof ShellTransportUnitsRdwRoute
  '/_shell/trips/$id': typeof ShellTripsIdRoute
  '/_shell/warehouse-orders_/new': typeof ShellWarehouseOrdersNewRoute
  '/_shell/warehouse/articles': typeof ShellWarehouseArticlesRoute
  '/_shell/warehouse/confirmations': typeof ShellWarehouseConfirmationsRoute
  '/_shell/warehouse/crossdock': typeof ShellWarehouseCrossdockRoute
  '/_shell/warehouse/locations': typeof ShellWarehouseLocationsRoute
  '/_shell/warehouse/replenishment': typeof ShellWarehouseReplenishmentRoute
  '/_shell/warehouse/scanner-users': typeof ShellWarehouseScannerUsersRoute
  '/_shell/warehouse/stock': typeof ShellWarehouseStockRoute
  '/_shell/warehouse/vas': typeof ShellWarehouseVasRoute
  '/_shell/warehouse/work': typeof ShellWarehouseWorkRoute
  '/_shell/calendar/': typeof ShellCalendarIndexRoute
  '/_shell/dossiers/': typeof ShellDossiersIndexRoute
  '/_shell/drivers/': typeof ShellDriversIndexRoute
  '/_shell/intake/': typeof ShellIntakeIndexRoute
  '/_shell/locations/': typeof ShellLocationsIndexRoute
  '/_shell/mail/': typeof ShellMailIndexRoute
  '/_shell/orders/': typeof ShellOrdersIndexRoute
  '/_shell/pallet-accounts/': typeof ShellPalletAccountsIndexRoute
  '/_shell/parties/': typeof ShellPartiesIndexRoute
  '/_shell/purchase-invoices/': typeof ShellPurchaseInvoicesIndexRoute
  '/_shell/requirements/': typeof ShellRequirementsIndexRoute
  '/_shell/reservations/': typeof ShellReservationsIndexRoute
  '/_shell/standing-orders/': typeof ShellStandingOrdersIndexRoute
  '/_shell/tasks/': typeof ShellTasksIndexRoute
  '/_shell/transport-units/': typeof ShellTransportUnitsIndexRoute
  '/_shell/trips/': typeof ShellTripsIndexRoute
  '/_shell/billing/tariffs/$id': typeof ShellBillingTariffsIdRoute
  '/_shell/orders/new_/from-message': typeof ShellOrdersNewFromMessageRoute
  '/_shell/transport-units/equipment/$id': typeof ShellTransportUnitsEquipmentIdRoute
  '/_shell/transport-units/vehicles/$id': typeof ShellTransportUnitsVehiclesIdRoute
  '/_shell/warehouse/inbound/$id': typeof ShellWarehouseInboundIdRoute
  '/_shell/warehouse/outbound/$id': typeof ShellWarehouseOutboundIdRoute
  '/_shell/warehouse/settings/$ownerId': typeof ShellWarehouseSettingsOwnerIdRoute
  '/_shell/billing/tariffs/': typeof ShellBillingTariffsIndexRoute
  '/_shell/warehouse/inbound/': typeof ShellWarehouseInboundIndexRoute
  '/_shell/warehouse/outbound/': typeof ShellWarehouseOutboundIndexRoute
  '/_shell/warehouse/settings/': typeof ShellWarehouseSettingsIndexRoute
  '/_shell/billing/tariffs/customers/$partyId': typeof ShellBillingTariffsCustomersPartyIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bulk-count-sheet'
    | '/count-sheet'
    | '/intake-window'
    | '/login'
    | '/mail-compose'
    | '/mail-window'
    | '/planning-map'
    | '/adr-codes'
    | '/branches'
    | '/carry-over'
    | '/consignment-requirements'
    | '/dashboard'
    | '/document-check'
    | '/documents'
    | '/focus-areas'
    | '/integrations'
    | '/missing-cmrs'
    | '/order-mails'
    | '/org'
    | '/pallet-check'
    | '/pendel-routes'
    | '/performance'
    | '/permissions'
    | '/planning'
    | '/scan-desk'
    | '/secrets'
    | '/tracking'
    | '/users'
    | '/warehouse-orders'
    | '/worklists'
    | '/billing/diesel'
    | '/billing/invoices'
    | '/billing/warehouse'
    | '/dossiers/$id'
    | '/drivers/$id'
    | '/intake/$id'
    | '/locations/$id'
    | '/locations/duplicates'
    | '/mail/mailboxes'
    | '/orders/$id'
    | '/orders/new'
    | '/pallet-accounts/$partyId'
    | '/parties/$id'
    | '/purchase-invoices/$id'
    | '/purchase-invoices/coding-rules'
    | '/purchase-invoices/fuel-card-products'
    | '/purchase-invoices/read-feedback'
    | '/reservations/resources'
    | '/standing-orders/$id'
    | '/tasks/$id'
    | '/tasks/categories'
    | '/tasks/recurring'
    | '/transport-units/rdw'
    | '/trips/$id'
    | '/warehouse-orders/new'
    | '/warehouse/articles'
    | '/warehouse/confirmations'
    | '/warehouse/crossdock'
    | '/warehouse/locations'
    | '/warehouse/replenishment'
    | '/warehouse/scanner-users'
    | '/warehouse/stock'
    | '/warehouse/vas'
    | '/warehouse/work'
    | '/calendar/'
    | '/dossiers/'
    | '/drivers/'
    | '/intake/'
    | '/locations/'
    | '/mail/'
    | '/orders/'
    | '/pallet-accounts/'
    | '/parties/'
    | '/purchase-invoices/'
    | '/requirements/'
    | '/reservations/'
    | '/standing-orders/'
    | '/tasks/'
    | '/transport-units/'
    | '/trips/'
    | '/billing/tariffs/$id'
    | '/orders/new/from-message'
    | '/transport-units/equipment/$id'
    | '/transport-units/vehicles/$id'
    | '/warehouse/inbound/$id'
    | '/warehouse/outbound/$id'
    | '/warehouse/settings/$ownerId'
    | '/billing/tariffs/'
    | '/warehouse/inbound/'
    | '/warehouse/outbound/'
    | '/warehouse/settings/'
    | '/billing/tariffs/customers/$partyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bulk-count-sheet'
    | '/count-sheet'
    | '/intake-window'
    | '/login'
    | '/mail-compose'
    | '/mail-window'
    | '/planning-map'
    | '/adr-codes'
    | '/branches'
    | '/carry-over'
    | '/consignment-requirements'
    | '/dashboard'
    | '/document-check'
    | '/documents'
    | '/focus-areas'
    | '/integrations'
    | '/missing-cmrs'
    | '/order-mails'
    | '/org'
    | '/pallet-check'
    | '/pendel-routes'
    | '/performance'
    | '/permissions'
    | '/planning'
    | '/scan-desk'
    | '/secrets'
    | '/tracking'
    | '/users'
    | '/warehouse-orders'
    | '/worklists'
    | '/billing/diesel'
    | '/billing/invoices'
    | '/billing/warehouse'
    | '/dossiers/$id'
    | '/drivers/$id'
    | '/intake/$id'
    | '/locations/$id'
    | '/locations/duplicates'
    | '/mail/mailboxes'
    | '/orders/$id'
    | '/orders/new'
    | '/pallet-accounts/$partyId'
    | '/parties/$id'
    | '/purchase-invoices/$id'
    | '/purchase-invoices/coding-rules'
    | '/purchase-invoices/fuel-card-products'
    | '/purchase-invoices/read-feedback'
    | '/reservations/resources'
    | '/standing-orders/$id'
    | '/tasks/$id'
    | '/tasks/categories'
    | '/tasks/recurring'
    | '/transport-units/rdw'
    | '/trips/$id'
    | '/warehouse-orders/new'
    | '/warehouse/articles'
    | '/warehouse/confirmations'
    | '/warehouse/crossdock'
    | '/warehouse/locations'
    | '/warehouse/replenishment'
    | '/warehouse/scanner-users'
    | '/warehouse/stock'
    | '/warehouse/vas'
    | '/warehouse/work'
    | '/calendar'
    | '/dossiers'
    | '/drivers'
    | '/intake'
    | '/locations'
    | '/mail'
    | '/orders'
    | '/pallet-accounts'
    | '/parties'
    | '/purchase-invoices'
    | '/requirements'
    | '/reservations'
    | '/standing-orders'
    | '/tasks'
    | '/transport-units'
    | '/trips'
    | '/billing/tariffs/$id'
    | '/orders/new/from-message'
    | '/transport-units/equipment/$id'
    | '/transport-units/vehicles/$id'
    | '/warehouse/inbound/$id'
    | '/warehouse/outbound/$id'
    | '/warehouse/settings/$ownerId'
    | '/billing/tariffs'
    | '/warehouse/inbound'
    | '/warehouse/outbound'
    | '/warehouse/settings'
    | '/billing/tariffs/customers/$partyId'
  id:
    | '__root__'
    | '/'
    | '/_shell'
    | '/bulk-count-sheet'
    | '/count-sheet'
    | '/intake-window'
    | '/login'
    | '/mail-compose'
    | '/mail-window'
    | '/planning-map'
    | '/_shell/adr-codes'
    | '/_shell/branches'
    | '/_shell/carry-over'
    | '/_shell/consignment-requirements'
    | '/_shell/dashboard'
    | '/_shell/document-check'
    | '/_shell/documents'
    | '/_shell/focus-areas'
    | '/_shell/integrations'
    | '/_shell/missing-cmrs'
    | '/_shell/order-mails'
    | '/_shell/org'
    | '/_shell/pallet-check'
    | '/_shell/pendel-routes'
    | '/_shell/performance'
    | '/_shell/permissions'
    | '/_shell/planning'
    | '/_shell/scan-desk'
    | '/_shell/secrets'
    | '/_shell/tracking'
    | '/_shell/users'
    | '/_shell/warehouse-orders'
    | '/_shell/worklists'
    | '/_shell/billing/diesel'
    | '/_shell/billing/invoices'
    | '/_shell/billing/warehouse'
    | '/_shell/dossiers/$id'
    | '/_shell/drivers/$id'
    | '/_shell/intake/$id'
    | '/_shell/locations/$id'
    | '/_shell/locations/duplicates'
    | '/_shell/mail/mailboxes'
    | '/_shell/orders/$id'
    | '/_shell/orders/new'
    | '/_shell/pallet-accounts/$partyId'
    | '/_shell/parties/$id'
    | '/_shell/purchase-invoices/$id'
    | '/_shell/purchase-invoices/coding-rules'
    | '/_shell/purchase-invoices/fuel-card-products'
    | '/_shell/purchase-invoices/read-feedback'
    | '/_shell/reservations/resources'
    | '/_shell/standing-orders/$id'
    | '/_shell/tasks/$id'
    | '/_shell/tasks/categories'
    | '/_shell/tasks/recurring'
    | '/_shell/transport-units/rdw'
    | '/_shell/trips/$id'
    | '/_shell/warehouse-orders_/new'
    | '/_shell/warehouse/articles'
    | '/_shell/warehouse/confirmations'
    | '/_shell/warehouse/crossdock'
    | '/_shell/warehouse/locations'
    | '/_shell/warehouse/replenishment'
    | '/_shell/warehouse/scanner-users'
    | '/_shell/warehouse/stock'
    | '/_shell/warehouse/vas'
    | '/_shell/warehouse/work'
    | '/_shell/calendar/'
    | '/_shell/dossiers/'
    | '/_shell/drivers/'
    | '/_shell/intake/'
    | '/_shell/locations/'
    | '/_shell/mail/'
    | '/_shell/orders/'
    | '/_shell/pallet-accounts/'
    | '/_shell/parties/'
    | '/_shell/purchase-invoices/'
    | '/_shell/requirements/'
    | '/_shell/reservations/'
    | '/_shell/standing-orders/'
    | '/_shell/tasks/'
    | '/_shell/transport-units/'
    | '/_shell/trips/'
    | '/_shell/billing/tariffs/$id'
    | '/_shell/orders/new_/from-message'
    | '/_shell/transport-units/equipment/$id'
    | '/_shell/transport-units/vehicles/$id'
    | '/_shell/warehouse/inbound/$id'
    | '/_shell/warehouse/outbound/$id'
    | '/_shell/warehouse/settings/$ownerId'
    | '/_shell/billing/tariffs/'
    | '/_shell/warehouse/inbound/'
    | '/_shell/warehouse/outbound/'
    | '/_shell/warehouse/settings/'
    | '/_shell/billing/tariffs/customers/$partyId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ShellRoute: typeof ShellRouteWithChildren
  BulkCountSheetRoute: typeof BulkCountSheetRoute
  CountSheetRoute: typeof CountSheetRoute
  IntakeWindowRoute: typeof IntakeWindowRoute
  LoginRoute: typeof LoginRoute
  MailComposeRoute: typeof MailComposeRoute
  MailWindowRoute: typeof MailWindowRoute
  PlanningMapRoute: typeof PlanningMapRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/planning-map': {
      id: '/planning-map'
      path: '/planning-map'
      fullPath: '/planning-map'
      preLoaderRoute: typeof PlanningMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mail-window': {
      id: '/mail-window'
      path: '/mail-window'
      fullPath: '/mail-window'
      preLoaderRoute: typeof MailWindowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mail-compose': {
      id: '/mail-compose'
      path: '/mail-compose'
      fullPath: '/mail-compose'
      preLoaderRoute: typeof MailComposeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intake-window': {
      id: '/intake-window'
      path: '/intake-window'
      fullPath: '/intake-window'
      preLoaderRoute: typeof IntakeWindowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/count-sheet': {
      id: '/count-sheet'
      path: '/count-sheet'
      fullPath: '/count-sheet'
      preLoaderRoute: typeof CountSheetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bulk-count-sheet': {
      id: '/bulk-count-sheet'
      path: '/bulk-count-sheet'
      fullPath: '/bulk-count-sheet'
      preLoaderRoute: typeof BulkCountSheetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/worklists': {
      id: '/_shell/worklists'
      path: '/worklists'
      fullPath: '/worklists'
      preLoaderRoute: typeof ShellWorklistsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse-orders': {
      id: '/_shell/warehouse-orders'
      path: '/warehouse-orders'
      fullPath: '/warehouse-orders'
      preLoaderRoute: typeof ShellWarehouseOrdersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/users': {
      id: '/_shell/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof ShellUsersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tracking': {
      id: '/_shell/tracking'
      path: '/tracking'
      fullPath: '/tracking'
      preLoaderRoute: typeof ShellTrackingRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/secrets': {
      id: '/_shell/secrets'
      path: '/secrets'
      fullPath: '/secrets'
      preLoaderRoute: typeof ShellSecretsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/scan-desk': {
      id: '/_shell/scan-desk'
      path: '/scan-desk'
      fullPath: '/scan-desk'
      preLoaderRoute: typeof ShellScanDeskRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/planning': {
      id: '/_shell/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof ShellPlanningRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/permissions': {
      id: '/_shell/permissions'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof ShellPermissionsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/performance': {
      id: '/_shell/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof ShellPerformanceRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/pendel-routes': {
      id: '/_shell/pendel-routes'
      path: '/pendel-routes'
      fullPath: '/pendel-routes'
      preLoaderRoute: typeof ShellPendelRoutesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/pallet-check': {
      id: '/_shell/pallet-check'
      path: '/pallet-check'
      fullPath: '/pallet-check'
      preLoaderRoute: typeof ShellPalletCheckRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/org': {
      id: '/_shell/org'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof ShellOrgRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/order-mails': {
      id: '/_shell/order-mails'
      path: '/order-mails'
      fullPath: '/order-mails'
      preLoaderRoute: typeof ShellOrderMailsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/missing-cmrs': {
      id: '/_shell/missing-cmrs'
      path: '/missing-cmrs'
      fullPath: '/missing-cmrs'
      preLoaderRoute: typeof ShellMissingCmrsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/integrations': {
      id: '/_shell/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof ShellIntegrationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/focus-areas': {
      id: '/_shell/focus-areas'
      path: '/focus-areas'
      fullPath: '/focus-areas'
      preLoaderRoute: typeof ShellFocusAreasRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/documents': {
      id: '/_shell/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof ShellDocumentsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/document-check': {
      id: '/_shell/document-check'
      path: '/document-check'
      fullPath: '/document-check'
      preLoaderRoute: typeof ShellDocumentCheckRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/dashboard': {
      id: '/_shell/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ShellDashboardRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/consignment-requirements': {
      id: '/_shell/consignment-requirements'
      path: '/consignment-requirements'
      fullPath: '/consignment-requirements'
      preLoaderRoute: typeof ShellConsignmentRequirementsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/carry-over': {
      id: '/_shell/carry-over'
      path: '/carry-over'
      fullPath: '/carry-over'
      preLoaderRoute: typeof ShellCarryOverRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/branches': {
      id: '/_shell/branches'
      path: '/branches'
      fullPath: '/branches'
      preLoaderRoute: typeof ShellBranchesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/adr-codes': {
      id: '/_shell/adr-codes'
      path: '/adr-codes'
      fullPath: '/adr-codes'
      preLoaderRoute: typeof ShellAdrCodesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/trips/': {
      id: '/_shell/trips/'
      path: '/trips'
      fullPath: '/trips/'
      preLoaderRoute: typeof ShellTripsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/transport-units/': {
      id: '/_shell/transport-units/'
      path: '/transport-units'
      fullPath: '/transport-units/'
      preLoaderRoute: typeof ShellTransportUnitsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tasks/': {
      id: '/_shell/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof ShellTasksIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/standing-orders/': {
      id: '/_shell/standing-orders/'
      path: '/standing-orders'
      fullPath: '/standing-orders/'
      preLoaderRoute: typeof ShellStandingOrdersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/reservations/': {
      id: '/_shell/reservations/'
      path: '/reservations'
      fullPath: '/reservations/'
      preLoaderRoute: typeof ShellReservationsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/requirements/': {
      id: '/_shell/requirements/'
      path: '/requirements'
      fullPath: '/requirements/'
      preLoaderRoute: typeof ShellRequirementsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/purchase-invoices/': {
      id: '/_shell/purchase-invoices/'
      path: '/purchase-invoices'
      fullPath: '/purchase-invoices/'
      preLoaderRoute: typeof ShellPurchaseInvoicesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/parties/': {
      id: '/_shell/parties/'
      path: '/parties'
      fullPath: '/parties/'
      preLoaderRoute: typeof ShellPartiesIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/pallet-accounts/': {
      id: '/_shell/pallet-accounts/'
      path: '/pallet-accounts'
      fullPath: '/pallet-accounts/'
      preLoaderRoute: typeof ShellPalletAccountsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders/': {
      id: '/_shell/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof ShellOrdersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/mail/': {
      id: '/_shell/mail/'
      path: '/mail'
      fullPath: '/mail/'
      preLoaderRoute: typeof ShellMailIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/locations/': {
      id: '/_shell/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof ShellLocationsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/intake/': {
      id: '/_shell/intake/'
      path: '/intake'
      fullPath: '/intake/'
      preLoaderRoute: typeof ShellIntakeIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/drivers/': {
      id: '/_shell/drivers/'
      path: '/drivers'
      fullPath: '/drivers/'
      preLoaderRoute: typeof ShellDriversIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/dossiers/': {
      id: '/_shell/dossiers/'
      path: '/dossiers'
      fullPath: '/dossiers/'
      preLoaderRoute: typeof ShellDossiersIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/calendar/': {
      id: '/_shell/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof ShellCalendarIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/work': {
      id: '/_shell/warehouse/work'
      path: '/warehouse/work'
      fullPath: '/warehouse/work'
      preLoaderRoute: typeof ShellWarehouseWorkRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/vas': {
      id: '/_shell/warehouse/vas'
      path: '/warehouse/vas'
      fullPath: '/warehouse/vas'
      preLoaderRoute: typeof ShellWarehouseVasRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/stock': {
      id: '/_shell/warehouse/stock'
      path: '/warehouse/stock'
      fullPath: '/warehouse/stock'
      preLoaderRoute: typeof ShellWarehouseStockRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/scanner-users': {
      id: '/_shell/warehouse/scanner-users'
      path: '/warehouse/scanner-users'
      fullPath: '/warehouse/scanner-users'
      preLoaderRoute: typeof ShellWarehouseScannerUsersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/replenishment': {
      id: '/_shell/warehouse/replenishment'
      path: '/warehouse/replenishment'
      fullPath: '/warehouse/replenishment'
      preLoaderRoute: typeof ShellWarehouseReplenishmentRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/locations': {
      id: '/_shell/warehouse/locations'
      path: '/warehouse/locations'
      fullPath: '/warehouse/locations'
      preLoaderRoute: typeof ShellWarehouseLocationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/crossdock': {
      id: '/_shell/warehouse/crossdock'
      path: '/warehouse/crossdock'
      fullPath: '/warehouse/crossdock'
      preLoaderRoute: typeof ShellWarehouseCrossdockRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/confirmations': {
      id: '/_shell/warehouse/confirmations'
      path: '/warehouse/confirmations'
      fullPath: '/warehouse/confirmations'
      preLoaderRoute: typeof ShellWarehouseConfirmationsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/articles': {
      id: '/_shell/warehouse/articles'
      path: '/warehouse/articles'
      fullPath: '/warehouse/articles'
      preLoaderRoute: typeof ShellWarehouseArticlesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse-orders_/new': {
      id: '/_shell/warehouse-orders_/new'
      path: '/warehouse-orders/new'
      fullPath: '/warehouse-orders/new'
      preLoaderRoute: typeof ShellWarehouseOrdersNewRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/trips/$id': {
      id: '/_shell/trips/$id'
      path: '/trips/$id'
      fullPath: '/trips/$id'
      preLoaderRoute: typeof ShellTripsIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/transport-units/rdw': {
      id: '/_shell/transport-units/rdw'
      path: '/transport-units/rdw'
      fullPath: '/transport-units/rdw'
      preLoaderRoute: typeof ShellTransportUnitsRdwRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tasks/recurring': {
      id: '/_shell/tasks/recurring'
      path: '/tasks/recurring'
      fullPath: '/tasks/recurring'
      preLoaderRoute: typeof ShellTasksRecurringRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tasks/categories': {
      id: '/_shell/tasks/categories'
      path: '/tasks/categories'
      fullPath: '/tasks/categories'
      preLoaderRoute: typeof ShellTasksCategoriesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/tasks/$id': {
      id: '/_shell/tasks/$id'
      path: '/tasks/$id'
      fullPath: '/tasks/$id'
      preLoaderRoute: typeof ShellTasksIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/standing-orders/$id': {
      id: '/_shell/standing-orders/$id'
      path: '/standing-orders/$id'
      fullPath: '/standing-orders/$id'
      preLoaderRoute: typeof ShellStandingOrdersIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/reservations/resources': {
      id: '/_shell/reservations/resources'
      path: '/reservations/resources'
      fullPath: '/reservations/resources'
      preLoaderRoute: typeof ShellReservationsResourcesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/purchase-invoices/read-feedback': {
      id: '/_shell/purchase-invoices/read-feedback'
      path: '/purchase-invoices/read-feedback'
      fullPath: '/purchase-invoices/read-feedback'
      preLoaderRoute: typeof ShellPurchaseInvoicesReadFeedbackRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/purchase-invoices/fuel-card-products': {
      id: '/_shell/purchase-invoices/fuel-card-products'
      path: '/purchase-invoices/fuel-card-products'
      fullPath: '/purchase-invoices/fuel-card-products'
      preLoaderRoute: typeof ShellPurchaseInvoicesFuelCardProductsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/purchase-invoices/coding-rules': {
      id: '/_shell/purchase-invoices/coding-rules'
      path: '/purchase-invoices/coding-rules'
      fullPath: '/purchase-invoices/coding-rules'
      preLoaderRoute: typeof ShellPurchaseInvoicesCodingRulesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/purchase-invoices/$id': {
      id: '/_shell/purchase-invoices/$id'
      path: '/purchase-invoices/$id'
      fullPath: '/purchase-invoices/$id'
      preLoaderRoute: typeof ShellPurchaseInvoicesIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/parties/$id': {
      id: '/_shell/parties/$id'
      path: '/parties/$id'
      fullPath: '/parties/$id'
      preLoaderRoute: typeof ShellPartiesIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/pallet-accounts/$partyId': {
      id: '/_shell/pallet-accounts/$partyId'
      path: '/pallet-accounts/$partyId'
      fullPath: '/pallet-accounts/$partyId'
      preLoaderRoute: typeof ShellPalletAccountsPartyIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders/new': {
      id: '/_shell/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof ShellOrdersNewRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders/$id': {
      id: '/_shell/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof ShellOrdersIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/mail/mailboxes': {
      id: '/_shell/mail/mailboxes'
      path: '/mail/mailboxes'
      fullPath: '/mail/mailboxes'
      preLoaderRoute: typeof ShellMailMailboxesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/locations/duplicates': {
      id: '/_shell/locations/duplicates'
      path: '/locations/duplicates'
      fullPath: '/locations/duplicates'
      preLoaderRoute: typeof ShellLocationsDuplicatesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/locations/$id': {
      id: '/_shell/locations/$id'
      path: '/locations/$id'
      fullPath: '/locations/$id'
      preLoaderRoute: typeof ShellLocationsIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/intake/$id': {
      id: '/_shell/intake/$id'
      path: '/intake/$id'
      fullPath: '/intake/$id'
      preLoaderRoute: typeof ShellIntakeIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/drivers/$id': {
      id: '/_shell/drivers/$id'
      path: '/drivers/$id'
      fullPath: '/drivers/$id'
      preLoaderRoute: typeof ShellDriversIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/dossiers/$id': {
      id: '/_shell/dossiers/$id'
      path: '/dossiers/$id'
      fullPath: '/dossiers/$id'
      preLoaderRoute: typeof ShellDossiersIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/billing/warehouse': {
      id: '/_shell/billing/warehouse'
      path: '/billing/warehouse'
      fullPath: '/billing/warehouse'
      preLoaderRoute: typeof ShellBillingWarehouseRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/billing/invoices': {
      id: '/_shell/billing/invoices'
      path: '/billing/invoices'
      fullPath: '/billing/invoices'
      preLoaderRoute: typeof ShellBillingInvoicesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/billing/diesel': {
      id: '/_shell/billing/diesel'
      path: '/billing/diesel'
      fullPath: '/billing/diesel'
      preLoaderRoute: typeof ShellBillingDieselRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/settings/': {
      id: '/_shell/warehouse/settings/'
      path: '/warehouse/settings'
      fullPath: '/warehouse/settings/'
      preLoaderRoute: typeof ShellWarehouseSettingsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/outbound/': {
      id: '/_shell/warehouse/outbound/'
      path: '/warehouse/outbound'
      fullPath: '/warehouse/outbound/'
      preLoaderRoute: typeof ShellWarehouseOutboundIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/inbound/': {
      id: '/_shell/warehouse/inbound/'
      path: '/warehouse/inbound'
      fullPath: '/warehouse/inbound/'
      preLoaderRoute: typeof ShellWarehouseInboundIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/billing/tariffs/': {
      id: '/_shell/billing/tariffs/'
      path: '/billing/tariffs'
      fullPath: '/billing/tariffs/'
      preLoaderRoute: typeof ShellBillingTariffsIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/settings/$ownerId': {
      id: '/_shell/warehouse/settings/$ownerId'
      path: '/warehouse/settings/$ownerId'
      fullPath: '/warehouse/settings/$ownerId'
      preLoaderRoute: typeof ShellWarehouseSettingsOwnerIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/outbound/$id': {
      id: '/_shell/warehouse/outbound/$id'
      path: '/warehouse/outbound/$id'
      fullPath: '/warehouse/outbound/$id'
      preLoaderRoute: typeof ShellWarehouseOutboundIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/warehouse/inbound/$id': {
      id: '/_shell/warehouse/inbound/$id'
      path: '/warehouse/inbound/$id'
      fullPath: '/warehouse/inbound/$id'
      preLoaderRoute: typeof ShellWarehouseInboundIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/transport-units/vehicles/$id': {
      id: '/_shell/transport-units/vehicles/$id'
      path: '/transport-units/vehicles/$id'
      fullPath: '/transport-units/vehicles/$id'
      preLoaderRoute: typeof ShellTransportUnitsVehiclesIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/transport-units/equipment/$id': {
      id: '/_shell/transport-units/equipment/$id'
      path: '/transport-units/equipment/$id'
      fullPath: '/transport-units/equipment/$id'
      preLoaderRoute: typeof ShellTransportUnitsEquipmentIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/orders/new_/from-message': {
      id: '/_shell/orders/new_/from-message'
      path: '/orders/new/from-message'
      fullPath: '/orders/new/from-message'
      preLoaderRoute: typeof ShellOrdersNewFromMessageRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/billing/tariffs/$id': {
      id: '/_shell/billing/tariffs/$id'
      path: '/billing/tariffs/$id'
      fullPath: '/billing/tariffs/$id'
      preLoaderRoute: typeof ShellBillingTariffsIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/billing/tariffs/customers/$partyId': {
      id: '/_shell/billing/tariffs/customers/$partyId'
      path: '/billing/tariffs/customers/$partyId'
      fullPath: '/billing/tariffs/customers/$partyId'
      preLoaderRoute: typeof ShellBillingTariffsCustomersPartyIdRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellAdrCodesRoute: typeof ShellAdrCodesRoute
  ShellBranchesRoute: typeof ShellBranchesRoute
  ShellCarryOverRoute: typeof ShellCarryOverRoute
  ShellConsignmentRequirementsRoute: typeof ShellConsignmentRequirementsRoute
  ShellDashboardRoute: typeof ShellDashboardRoute
  ShellDocumentCheckRoute: typeof ShellDocumentCheckRoute
  ShellDocumentsRoute: typeof ShellDocumentsRoute
  ShellFocusAreasRoute: typeof ShellFocusAreasRoute
  ShellIntegrationsRoute: typeof ShellIntegrationsRoute
  ShellMissingCmrsRoute: typeof ShellMissingCmrsRoute
  ShellOrderMailsRoute: typeof ShellOrderMailsRoute
  ShellOrgRoute: typeof ShellOrgRoute
  ShellPalletCheckRoute: typeof ShellPalletCheckRoute
  ShellPendelRoutesRoute: typeof ShellPendelRoutesRoute
  ShellPerformanceRoute: typeof ShellPerformanceRoute
  ShellPermissionsRoute: typeof ShellPermissionsRoute
  ShellPlanningRoute: typeof ShellPlanningRoute
  ShellScanDeskRoute: typeof ShellScanDeskRoute
  ShellSecretsRoute: typeof ShellSecretsRoute
  ShellTrackingRoute: typeof ShellTrackingRoute
  ShellUsersRoute: typeof ShellUsersRoute
  ShellWarehouseOrdersRoute: typeof ShellWarehouseOrdersRoute
  ShellWorklistsRoute: typeof ShellWorklistsRoute
  ShellBillingDieselRoute: typeof ShellBillingDieselRoute
  ShellBillingInvoicesRoute: typeof ShellBillingInvoicesRoute
  ShellBillingWarehouseRoute: typeof ShellBillingWarehouseRoute
  ShellDossiersIdRoute: typeof ShellDossiersIdRoute
  ShellDriversIdRoute: typeof ShellDriversIdRoute
  ShellIntakeIdRoute: typeof ShellIntakeIdRoute
  ShellLocationsIdRoute: typeof ShellLocationsIdRoute
  ShellLocationsDuplicatesRoute: typeof ShellLocationsDuplicatesRoute
  ShellMailMailboxesRoute: typeof ShellMailMailboxesRoute
  ShellOrdersIdRoute: typeof ShellOrdersIdRoute
  ShellOrdersNewRoute: typeof ShellOrdersNewRoute
  ShellPalletAccountsPartyIdRoute: typeof ShellPalletAccountsPartyIdRoute
  ShellPartiesIdRoute: typeof ShellPartiesIdRoute
  ShellPurchaseInvoicesIdRoute: typeof ShellPurchaseInvoicesIdRoute
  ShellPurchaseInvoicesCodingRulesRoute: typeof ShellPurchaseInvoicesCodingRulesRoute
  ShellPurchaseInvoicesFuelCardProductsRoute: typeof ShellPurchaseInvoicesFuelCardProductsRoute
  ShellPurchaseInvoicesReadFeedbackRoute: typeof ShellPurchaseInvoicesReadFeedbackRoute
  ShellReservationsResourcesRoute: typeof ShellReservationsResourcesRoute
  ShellStandingOrdersIdRoute: typeof ShellStandingOrdersIdRoute
  ShellTasksIdRoute: typeof ShellTasksIdRoute
  ShellTasksCategoriesRoute: typeof ShellTasksCategoriesRoute
  ShellTasksRecurringRoute: typeof ShellTasksRecurringRoute
  ShellTransportUnitsRdwRoute: typeof ShellTransportUnitsRdwRoute
  ShellTripsIdRoute: typeof ShellTripsIdRoute
  ShellWarehouseOrdersNewRoute: typeof ShellWarehouseOrdersNewRoute
  ShellWarehouseArticlesRoute: typeof ShellWarehouseArticlesRoute
  ShellWarehouseConfirmationsRoute: typeof ShellWarehouseConfirmationsRoute
  ShellWarehouseCrossdockRoute: typeof ShellWarehouseCrossdockRoute
  ShellWarehouseLocationsRoute: typeof ShellWarehouseLocationsRoute
  ShellWarehouseReplenishmentRoute: typeof ShellWarehouseReplenishmentRoute
  ShellWarehouseScannerUsersRoute: typeof ShellWarehouseScannerUsersRoute
  ShellWarehouseStockRoute: typeof ShellWarehouseStockRoute
  ShellWarehouseVasRoute: typeof ShellWarehouseVasRoute
  ShellWarehouseWorkRoute: typeof ShellWarehouseWorkRoute
  ShellCalendarIndexRoute: typeof ShellCalendarIndexRoute
  ShellDossiersIndexRoute: typeof ShellDossiersIndexRoute
  ShellDriversIndexRoute: typeof ShellDriversIndexRoute
  ShellIntakeIndexRoute: typeof ShellIntakeIndexRoute
  ShellLocationsIndexRoute: typeof ShellLocationsIndexRoute
  ShellMailIndexRoute: typeof ShellMailIndexRoute
  ShellOrdersIndexRoute: typeof ShellOrdersIndexRoute
  ShellPalletAccountsIndexRoute: typeof ShellPalletAccountsIndexRoute
  ShellPartiesIndexRoute: typeof ShellPartiesIndexRoute
  ShellPurchaseInvoicesIndexRoute: typeof ShellPurchaseInvoicesIndexRoute
  ShellRequirementsIndexRoute: typeof ShellRequirementsIndexRoute
  ShellReservationsIndexRoute: typeof ShellReservationsIndexRoute
  ShellStandingOrdersIndexRoute: typeof ShellStandingOrdersIndexRoute
  ShellTasksIndexRoute: typeof ShellTasksIndexRoute
  ShellTransportUnitsIndexRoute: typeof ShellTransportUnitsIndexRoute
  ShellTripsIndexRoute: typeof ShellTripsIndexRoute
  ShellBillingTariffsIdRoute: typeof ShellBillingTariffsIdRoute
  ShellOrdersNewFromMessageRoute: typeof ShellOrdersNewFromMessageRoute
  ShellTransportUnitsEquipmentIdRoute: typeof ShellTransportUnitsEquipmentIdRoute
  ShellTransportUnitsVehiclesIdRoute: typeof ShellTransportUnitsVehiclesIdRoute
  ShellWarehouseInboundIdRoute: typeof ShellWarehouseInboundIdRoute
  ShellWarehouseOutboundIdRoute: typeof ShellWarehouseOutboundIdRoute
  ShellWarehouseSettingsOwnerIdRoute: typeof ShellWarehouseSettingsOwnerIdRoute
  ShellBillingTariffsIndexRoute: typeof ShellBillingTariffsIndexRoute
  ShellWarehouseInboundIndexRoute: typeof ShellWarehouseInboundIndexRoute
  ShellWarehouseOutboundIndexRoute: typeof ShellWarehouseOutboundIndexRoute
  ShellWarehouseSettingsIndexRoute: typeof ShellWarehouseSettingsIndexRoute
  ShellBillingTariffsCustomersPartyIdRoute: typeof ShellBillingTariffsCustomersPartyIdRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellAdrCodesRoute: ShellAdrCodesRoute,
  ShellBranchesRoute: ShellBranchesRoute,
  ShellCarryOverRoute: ShellCarryOverRoute,
  ShellConsignmentRequirementsRoute: ShellConsignmentRequirementsRoute,
  ShellDashboardRoute: ShellDashboardRoute,
  ShellDocumentCheckRoute: ShellDocumentCheckRoute,
  ShellDocumentsRoute: ShellDocumentsRoute,
  ShellFocusAreasRoute: ShellFocusAreasRoute,
  ShellIntegrationsRoute: ShellIntegrationsRoute,
  ShellMissingCmrsRoute: ShellMissingCmrsRoute,
  ShellOrderMailsRoute: ShellOrderMailsRoute,
  ShellOrgRoute: ShellOrgRoute,
  ShellPalletCheckRoute: ShellPalletCheckRoute,
  ShellPendelRoutesRoute: ShellPendelRoutesRoute,
  ShellPerformanceRoute: ShellPerformanceRoute,
  ShellPermissionsRoute: ShellPermissionsRoute,
  ShellPlanningRoute: ShellPlanningRoute,
  ShellScanDeskRoute: ShellScanDeskRoute,
  ShellSecretsRoute: ShellSecretsRoute,
  ShellTrackingRoute: ShellTrackingRoute,
  ShellUsersRoute: ShellUsersRoute,
  ShellWarehouseOrdersRoute: ShellWarehouseOrdersRoute,
  ShellWorklistsRoute: ShellWorklistsRoute,
  ShellBillingDieselRoute: ShellBillingDieselRoute,
  ShellBillingInvoicesRoute: ShellBillingInvoicesRoute,
  ShellBillingWarehouseRoute: ShellBillingWarehouseRoute,
  ShellDossiersIdRoute: ShellDossiersIdRoute,
  ShellDriversIdRoute: ShellDriversIdRoute,
  ShellIntakeIdRoute: ShellIntakeIdRoute,
  ShellLocationsIdRoute: ShellLocationsIdRoute,
  ShellLocationsDuplicatesRoute: ShellLocationsDuplicatesRoute,
  ShellMailMailboxesRoute: ShellMailMailboxesRoute,
  ShellOrdersIdRoute: ShellOrdersIdRoute,
  ShellOrdersNewRoute: ShellOrdersNewRoute,
  ShellPalletAccountsPartyIdRoute: ShellPalletAccountsPartyIdRoute,
  ShellPartiesIdRoute: ShellPartiesIdRoute,
  ShellPurchaseInvoicesIdRoute: ShellPurchaseInvoicesIdRoute,
  ShellPurchaseInvoicesCodingRulesRoute: ShellPurchaseInvoicesCodingRulesRoute,
  ShellPurchaseInvoicesFuelCardProductsRoute:
    ShellPurchaseInvoicesFuelCardProductsRoute,
  ShellPurchaseInvoicesReadFeedbackRoute:
    ShellPurchaseInvoicesReadFeedbackRoute,
  ShellReservationsResourcesRoute: ShellReservationsResourcesRoute,
  ShellStandingOrdersIdRoute: ShellStandingOrdersIdRoute,
  ShellTasksIdRoute: ShellTasksIdRoute,
  ShellTasksCategoriesRoute: ShellTasksCategoriesRoute,
  ShellTasksRecurringRoute: ShellTasksRecurringRoute,
  ShellTransportUnitsRdwRoute: ShellTransportUnitsRdwRoute,
  ShellTripsIdRoute: ShellTripsIdRoute,
  ShellWarehouseOrdersNewRoute: ShellWarehouseOrdersNewRoute,
  ShellWarehouseArticlesRoute: ShellWarehouseArticlesRoute,
  ShellWarehouseConfirmationsRoute: ShellWarehouseConfirmationsRoute,
  ShellWarehouseCrossdockRoute: ShellWarehouseCrossdockRoute,
  ShellWarehouseLocationsRoute: ShellWarehouseLocationsRoute,
  ShellWarehouseReplenishmentRoute: ShellWarehouseReplenishmentRoute,
  ShellWarehouseScannerUsersRoute: ShellWarehouseScannerUsersRoute,
  ShellWarehouseStockRoute: ShellWarehouseStockRoute,
  ShellWarehouseVasRoute: ShellWarehouseVasRoute,
  ShellWarehouseWorkRoute: ShellWarehouseWorkRoute,
  ShellCalendarIndexRoute: ShellCalendarIndexRoute,
  ShellDossiersIndexRoute: ShellDossiersIndexRoute,
  ShellDriversIndexRoute: ShellDriversIndexRoute,
  ShellIntakeIndexRoute: ShellIntakeIndexRoute,
  ShellLocationsIndexRoute: ShellLocationsIndexRoute,
  ShellMailIndexRoute: ShellMailIndexRoute,
  ShellOrdersIndexRoute: ShellOrdersIndexRoute,
  ShellPalletAccountsIndexRoute: ShellPalletAccountsIndexRoute,
  ShellPartiesIndexRoute: ShellPartiesIndexRoute,
  ShellPurchaseInvoicesIndexRoute: ShellPurchaseInvoicesIndexRoute,
  ShellRequirementsIndexRoute: ShellRequirementsIndexRoute,
  ShellReservationsIndexRoute: ShellReservationsIndexRoute,
  ShellStandingOrdersIndexRoute: ShellStandingOrdersIndexRoute,
  ShellTasksIndexRoute: ShellTasksIndexRoute,
  ShellTransportUnitsIndexRoute: ShellTransportUnitsIndexRoute,
  ShellTripsIndexRoute: ShellTripsIndexRoute,
  ShellBillingTariffsIdRoute: ShellBillingTariffsIdRoute,
  ShellOrdersNewFromMessageRoute: ShellOrdersNewFromMessageRoute,
  ShellTransportUnitsEquipmentIdRoute: ShellTransportUnitsEquipmentIdRoute,
  ShellTransportUnitsVehiclesIdRoute: ShellTransportUnitsVehiclesIdRoute,
  ShellWarehouseInboundIdRoute: ShellWarehouseInboundIdRoute,
  ShellWarehouseOutboundIdRoute: ShellWarehouseOutboundIdRoute,
  ShellWarehouseSettingsOwnerIdRoute: ShellWarehouseSettingsOwnerIdRoute,
  ShellBillingTariffsIndexRoute: ShellBillingTariffsIndexRoute,
  ShellWarehouseInboundIndexRoute: ShellWarehouseInboundIndexRoute,
  ShellWarehouseOutboundIndexRoute: ShellWarehouseOutboundIndexRoute,
  ShellWarehouseSettingsIndexRoute: ShellWarehouseSettingsIndexRoute,
  ShellBillingTariffsCustomersPartyIdRoute:
    ShellBillingTariffsCustomersPartyIdRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ShellRoute: ShellRouteWithChildren,
  BulkCountSheetRoute: BulkCountSheetRoute,
  CountSheetRoute: CountSheetRoute,
  IntakeWindowRoute: IntakeWindowRoute,
  LoginRoute: LoginRoute,
  MailComposeRoute: MailComposeRoute,
  MailWindowRoute: MailWindowRoute,
  PlanningMapRoute: PlanningMapRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
